import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid"; // Assuming you might want time-based views
import interactionPlugin from "@fullcalendar/interaction";
import ExternalEvents from "./WorkorderNotAssignList";
import moment from "moment";
import { Box, Button, Dialog, IconButton, Tooltip, Typography } from "@mui/material";
import { color } from "../../../StyleData/Config";
import { ArrowBack, Clear, Remove, RemoveCircle, RemoveCircleOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Component/Loading";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import tippy, { followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import TaskList from "./TaskList";
import LabourList from "./LabourList";

const MyCalendar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.auth.drawerOpen.open);
  const calendarRef = useRef(null);
  const [showLabour, setShowLabour] = useState(false);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [externalEvents, setExternalEvents] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [openUnschedule, setOpenUnschedule] = useState(true);
  const [selectedWorkOrder, setSelectedWO] = useState({
    id: "",
    start: "",
    end: "",
  });
  const [showTask, setShowTask] = useState(false);
  const [taskCollapse, setTaskCollapse] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [selectedTask, setSelectedTask] = useState([]);
  const [delWoDetail,setDelWODetail]=useState({})
  const [unScheduledWO,setUnScheduleWO]=useState(false)

 

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (calendarRef.current) {
      setTimeout(() => {
        calendarRef.current.getApi().updateSize();
      }, 300); // wait for animation if there's one
    }
  }, [drawerOpen]);

  const getData = () => {
    setLoadingData(true);
    const getAlreadyLink = masterAPI["calendarView"].getAlreadyAssignedWO;
    axiosPrivate
      .get(`${getAlreadyLink}`)
      .then((res) => {
        console.log(res);
        const addAllDay = res.data.result.map((item) => {
          {
            const comparValue = compareMomentObjects(
              moment(item.start),
              moment(item.end)
            );

            return {
              ...item,
              allDay:
                comparValue.areDifferentDates ||
                (!comparValue.areDifferentDates &&
                  !comparValue.areDifferentTimesOnSameDay),
            };
          }
        });
        console.log(addAllDay);
        setCalendarEvents(addAllDay);
      })
      .catch((e) => {
        setCalendarEvents([]);
        console.log(e);
      });
     getNotAssignedData()
    setLoadingData(false);
  };

  const getNotAssignedData=()=>{
      const getNotAssign = masterAPI["calendarView"].getWorkorderNotAssigned;
    axiosPrivate
      .get(`${getNotAssign}`)
      .then((res) => {
        console.log(res);
        setExternalEvents(res.data.result);
      })
      .catch((e) => {
        setExternalEvents([]);
        console.log(e);
      });
  }

  function compareMomentObjects(startDateMoment, endDateMoment) {
    if (
      !moment.isMoment(startDateMoment) ||
      !moment.isMoment(endDateMoment) ||
      !startDateMoment.isValid() ||
      !endDateMoment.isValid()
    ) {
      return {
        areDifferentDates: false,
        areDifferentTimesOnSameDay: false,
        comparisonError: "Invalid Moment object or date",
      };
    }

    const areSameDate = startDateMoment.isSame(endDateMoment, "day");
    const areSameTime = startDateMoment.isSame(endDateMoment, "second"); // Compare down to the second

    return {
      areDifferentDates: !areSameDate,
      areDifferentTimesOnSameDay: areSameDate && !areSameTime,
    };
  }

  const handleEventReceive = (info) => {
    const newEvent = info.event.toPlainObject();
    console.log(info.event.start);

    const updatedEvent = {
      id: info.event.id,
      title: info.event.title,
      start: info.event.start,
      end: info.event.start,
      allDay: info.event.allDay,
    };

    console.log(updatedEvent);

    const isDuplicate = calendarEvents.some(
      (event) => event.id === newEvent.id
    );

    if (isDuplicate) {
      info.revert();
      alert("Event already exists!");
    } else {
      const updateStartAndEnd = masterAPI["calendarView"].updatePlannedDate;
      const putData = {
        id: info.event.id,
        plannedStartDate: moment(info.event.start).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        plannedEndDate: moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss"),
      };
      console.log(putData, "backEnd");
      axiosPrivate
        .put(`${updateStartAndEnd}`, putData)
        .then((res) => {
          console.log(res);
          setCalendarEvents([
            ...calendarEvents,
            {
              ...newEvent,
              id: info.draggedEl.dataset.eventId,
              //     start: moment(), // For timed events
              // end: moment(),
              // allDay:info.draggedEl.dataset.allDay==="true"?true:false
            },
          ]);
          setExternalEvents(
            externalEvents.filter(
              (task) => task.id !== info.draggedEl.dataset.eventId
            )
          );
        })
        .catch((e) => {
          console.log(e);
        });

      // } else {
      //   info.revert();
      // In a real app, you'd also send this to your backend
    }
  };

  const handleEventDrop = (info) => {
    const updatedEvent = {
      id: info.event.id,
      title: info.event.title,
      start: info.event.startStr,
      end: info.event.endStr,
      allDay: info.event.allDay,
    };

    console.log(updatedEvent);
    const newEvents = calendarEvents.map((event) =>
      event.id === updatedEvent.id ? updatedEvent : event
    );
    const updateStartAndEnd = masterAPI["calendarView"].updatePlannedDate;
    const putData = {
      id: info.event.id,
      plannedStartDate: moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss"),
      plannedEndDate: moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss"),
    };
    console.log(putData, "backEnd");
    axiosPrivate
      .put(`${updateStartAndEnd}`, putData)
      .then((res) => {
        console.log(res);
        setCalendarEvents(newEvents);
      })
      .catch((e) => {
        console.log(e);
      });

    console.log("Event dropped:", updatedEvent);
  };

  const handleEventResize = (info) => {
    const updatedEvent = {
      id: info.event.id,
      title: info.event.title,
      start: info.event.startStr,
      end: info.event.endStr,
      // Add any other relevant properties you need to update
    };

    // Update the event in your state
    const newEvents = calendarEvents.map((event) =>
      event.id === updatedEvent.id ? updatedEvent : event
    );
    const updateStartAndEnd = masterAPI["calendarView"].updatePlannedDate;
    const putData = {
      id: info.event.id,
      plannedStartDate: moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss"),
      plannedEndDate: moment(info.event.end).format("YYYY-MM-DDTHH:mm:ss"),
    };
    console.log(putData, "backEnd");
    axiosPrivate
      .put(`${updateStartAndEnd}`, putData)
      .then((res) => {
        console.log(res);
        setCalendarEvents(newEvents);
      })
      .catch((e) => {
        console.log(e);
      });

    // Here, you would typically make an API call to update the event
    // on your server with the new end date.
    console.log("Event resized:", updatedEvent);
  };

  const handleTaskRefresh = (woId) => {
    const getTask = masterAPI["workOrderTask"].getByWorkOrderId;
    axiosPrivate
      .get(`${getTask}/${woId}`)
      .then((res) => {
        setTaskData(res.data.result);
        setTaskCollapse(true);
      })
      .catch((e) => {
        setTaskData([]);
        setTaskCollapse(false);
      });
  };

  const handleEventClick = (clickInfo) => {
    console.log(
      "test",
      clickInfo.event.start,
      clickInfo.event.end,
      clickInfo.event
    );

    const getTask = masterAPI["workOrderTask"].getByWorkOrderId;
    axiosPrivate
      .get(`${getTask}/${clickInfo.event.id}`)
      .then((res) => {
        console.log(res);
        setSelectedWO({
          id: clickInfo.event.id,
          start: clickInfo.event.start,
          end: clickInfo.event.end,
          name: clickInfo.event.title,
        });
        setTaskData(res.data.result);
        setTaskCollapse(true);
        setShowTask(true);
        setOpenUnschedule(false);
      })
      .catch((e) => {
        setSelectedWO({ id: "", start: "", end: "" });
        setTaskData([]);
        setTaskCollapse(false);
        setShowTask(false);
        setOpenUnschedule(true);
        console.log(e);
      });
  };

  
const removeUSWOCloseClick=()=>{
 setDelWODetail({})
 setUnScheduleWO(false)
}
  const handleDeleteEvent=(info)=>{
    const updateStartAndEnd = masterAPI["calendarView"].updatePlannedDate;
    const putData = {
      id: info.event.id,
      plannedStartDate:null ,
      plannedEndDate:null,
    };
    console.log(putData, "backEnd");
    axiosPrivate
      .put(`${updateStartAndEnd}`, putData)
      .then((res) => {
        console.log(res);
        
        setCalendarEvents((prev) => prev.filter((evt) => evt.id !== info.event.id));
        getNotAssignedData()
        removeUSWOCloseClick()
      })
      .catch((e) => {
        console.log(e);
      });

  }

  const handleEventContent = (arg) => {
   
    // if (!arg.event.allDay) {
    //   return (
    //     <div className="non-all-day-event">
    //       {" "}
    //       {/* Apply your custom class */}
    //       {arg.event.title}
    //     </div>
    //   );
    // }
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          paddingRight: "5px",
        }}
      >
        <Tooltip title={arg.event.title} placement="top">
          <Typography
            variant="body2"
            sx={{
              flexGrow: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              marginRight: "5px" /* Space between title and button */,
              fontSize: "0.9rem" /* Adjust font size for better fit */,
            }}
            onClick={()=>{handleEventClick(arg)}}
          >
            {arg.event.title}
          </Typography>
        </Tooltip>
        <IconButton
          size="small"
          onClick={(e) => {
            // e.stopPropagation(); // Prevent FullCalendar's event click handler
            setDelWODetail(arg)
            setUnScheduleWO(true)
          }}
          sx={{
            p: 0.2, // Smaller padding for the button
            ml: 0.5, // Margin left for spacing
            color: "#F50004", // MUI red color
            "&:hover": {
              // backgroundColor: "white", // Lighter red on hover
              color: "white",
            },
          }}
          aria-label="delete"
        >
          <RemoveCircleOutline fontSize="inherit" />
        </IconButton>
      </Box>
    ); // Default rendering for all-day events
  };

  // const handleEventDidMount = (info) => {
  //   tippy(info.el, {
  //     content: info.event.extendedProps.description || info.event.title, // Use a custom property or the title
  //     interactive: true,
  //     allowHTML: true, // If your description might contain HTML
  //     placement: "top",
  //     followCursor: "horizontal",
  //     delay: [100, 0],
  //   });
  // };

  const handleUnSchedule = () => {
    setOpenUnschedule(!openUnschedule);
  };

  const handleOpenTask = () => {
    setTaskCollapse(!taskCollapse);
  };

  const handleTaskSelect = (e) => {
    if (e.target.checked) {
      setSelectedTask([...selectedTask, e.target.value]);
    } else {
      const filterSelectTask = selectedTask.filter(
        (fil) => fil !== e.target.value
      );
      setSelectedTask(filterSelectTask);
    }
  };

  const handleEventDragStop = (info) => {
    const unscheduledEl = document.getElementById("unscheduledZone");

    if (unscheduledEl) {
      const rect = unscheduledEl.getBoundingClientRect();
      const { pageX, pageY } = info.jsEvent;

      if (
        pageX >= rect.left &&
        pageX <= rect.right &&
        pageY >= rect.top &&
        pageY <= rect.bottom
      ) {
        const eventId = info.event.id;
        setCalendarEvents((prev) => prev.filter((evt) => evt.id !== eventId));
      }
    }
  };

  const handleLabour = () => {
    setShowLabour(!showLabour);
  };

  return (
    <Box>
      <Box
        sx={{ display: "flex", alignItems: "center", gap: "1rem", mb: "2rem" }}
      >
        <IconButton
          onClick={() => {
            navigate("/workorder");
            dispatch({
              type: "drawerOpen",
              payload: { bol: false, open: false },
            });
          }}
        >
          <ArrowBack />
        </IconButton>
        <Typography
          sx={{
            // color: color.masterDialogTitleColor,
            // fontSize: color.masterDialogFontSize,
            fontSize: color.AssetTitlesize,
            fontWeight: color.sideFontWeightAsset,
          }}
        >
          Calendar View
        </Typography>
      </Box>
      {loadingData ? (
        <Loading />
      ) : (
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ flexGrow: 1 }}>
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]} // Make sure to include timeGridPlugin if you use time-based views
              initialView="dayGridMonth"
              dayMaxEventRows={3}
              eventMaxStack={1}
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay", // Include time-aware views
              }}
              // views={["dayGridMonth","timeGridWeek","timeGridDay"]}
              editable={true} // Enable dragging and resizing of events on the calendar
              droppable={true} // Enable dropping from external sources
              events={calendarEvents}
              eventReceive={handleEventReceive}
              eventDrop={handleEventDrop}
              eventResize={handleEventResize} // Callback for when an event is resized
              // eventClick={handleEventClick}
              // eventDidMount={handleEventDidMount}
              // eventDragStop={handleEventDragStop}
              eventContent={handleEventContent}
              // eventDurationEditable={true}
              drop={(info) => {
                console.log("Dropped on calendar:", info.dateStr);
              }}
            />
          </div>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {/* <Box id="unscheduledZone"> */}
            <ExternalEvents
              events={externalEvents}
              open={openUnschedule}
              handleOpen={handleUnSchedule}
            />
            {/* </Box> */}
            {showTask ? (
              <TaskList
                open={taskCollapse}
                handleOpen={handleOpenTask}
                taskData={taskData}
                selectedTask={selectedTask}
                handleSelect={handleTaskSelect}
                workOrderDetail={selectedWorkOrder}
                handleRefresh={handleTaskRefresh}
              />
            ) : null}

            <LabourList
              open={showLabour}
              handleOpen={handleLabour}
              selectedTask={selectedTask}
              workOrderDetail={selectedWorkOrder}
            />
          </Box>
        </div>
      )}
      <Dialog
        open={unScheduledWO}
        onClose={removeUSWOCloseClick}
        maxWidth={"md"}
  //      PaperProps={{
  //   sx: {
  //     maxWidth: '50vw', // set max width in viewport width
  //     width: '100%',     // optional, ensures it can grow to max
  //   }
  // }}
        children={<Box sx={{display:"flex",flexDirection:"column",alignItems:"center",gap:"1rem",p:2}}>
          <Typography variant="h6">Are You Sure Do You Want To Unschedule The Wordorder ({delWoDetail?.event?.title})?</Typography>
          <Box sx={{display:"flex",alignItems:"center",gap:"1rem"}}>
            <Button variant="contained" onClick={removeUSWOCloseClick}>No</Button>
            <Button variant="contained" onClick={()=>{handleDeleteEvent(delWoDetail)}}>Yes</Button>
            </Box>
        </Box>}
      />
    </Box>
  );
};

export default MyCalendar;
